import { Stack } from 'design-system'
import { FC } from 'react'
import { ArchivedBoardAdminViewProps } from './types'
import { UsernameMenu } from 'src/components/user/v2/username-menu/menu'
import { ExpandableSection } from './expandable-section'

export const ArchivedBoardAdminView: FC<ArchivedBoardAdminViewProps> = ({
  archivedBy,
  networkTitle,
  board
}) => {
  const { owner, loggedInBoardUser, archivedAt } = board
  const isUserArchiver = archivedBy.userId === loggedInBoardUser.userId
  const isArchiverOwner = archivedBy.userId === owner.id
  const archivedAtMoment = new Date(archivedAt).toLocaleDateString()

  return (
    <div className="py-4 text-left text-slate-500">
      The community you&apos;re trying to reach was archived by the{' '}
      {isArchiverOwner ? (
        'Community Owner '
      ) : (
        <>
          Administrator{' '}
          <UsernameMenu
            user={archivedBy.user}
            messageEnabled={false}
            isOwnProfile={isUserArchiver}
          />{' '}
        </>
      )}
      on {archivedAtMoment} and is no longer accessible.
      <Stack gap={3}>
        <ExpandableSection message="Who has permission to archive?">
          Only the Community Owner or a Yellowdig Administrator has the
          permission to archive a community.
        </ExpandableSection>
        <ExpandableSection message="Who should I contact with questions about this status?">
          If you have any questions regarding the archived status of this
          community, please contact the Community Owner or a Yellowdig
          Administrator for {networkTitle}.
        </ExpandableSection>
        <ExpandableSection message="Can a community be un-archived?">
          Yes, a community can be un-archived by the Owner or a Yellowdig
          Administrator for {networkTitle}.
        </ExpandableSection>
      </Stack>
    </div>
  )
}
